var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 13.8333C11.0404 13.8333 11.9258 13.4687 12.6549 12.7396C13.3841 12.0104 13.7487 11.125 13.7487 10.0833C13.7487 9.04165 13.3841 8.15623 12.6549 7.42706C11.9258 6.6979 11.0404 6.33331 9.9987 6.33331C8.95703 6.33331 8.07161 6.6979 7.34245 7.42706C6.61328 8.15623 6.2487 9.04165 6.2487 10.0833C6.2487 11.125 6.61328 12.0104 7.34245 12.7396C8.07161 13.4687 8.95703 13.8333 9.9987 13.8333ZM9.9987 12.3333C9.3737 12.3333 8.84245 12.1146 8.40495 11.6771C7.96745 11.2396 7.7487 10.7083 7.7487 10.0833C7.7487 9.45831 7.96745 8.92706 8.40495 8.48956C8.84245 8.05206 9.3737 7.83331 9.9987 7.83331C10.6237 7.83331 11.1549 8.05206 11.5924 8.48956C12.0299 8.92706 12.2487 9.45831 12.2487 10.0833C12.2487 10.7083 12.0299 11.2396 11.5924 11.6771C11.1549 12.1146 10.6237 12.3333 9.9987 12.3333ZM9.9987 16.3333C7.97092 16.3333 6.1237 15.7673 4.45703 14.6354C2.79036 13.5035 1.58203 11.9861 0.832031 10.0833C1.58203 8.18053 2.79036 6.66317 4.45703 5.53123C6.1237 4.39929 7.97092 3.83331 9.9987 3.83331C12.0265 3.83331 13.8737 4.39929 15.5404 5.53123C17.207 6.66317 18.4154 8.18053 19.1654 10.0833C18.4154 11.9861 17.207 13.5035 15.5404 14.6354C13.8737 15.7673 12.0265 16.3333 9.9987 16.3333Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ee2bc770bc29ddcb4572057f4f07bb8b.svg";
export { ForwardRef as ReactComponent };